import { createSlice } from '@reduxjs/toolkit';
import { getNotifications } from '../../../rtk-apis/reports/getNotifications';
import { markNotificationRead } from '../../../rtk-apis/reports/markNotificationRead';
import { markAllNotificationsRead } from '../../../rtk-apis/reports/markAllNotificationsRead';

export type AppNotification = {
  _id: string;
  recipientUserId: string;
  reportId?: string;
  hospitalId?: string;
  studyInstanceUID?: string;
  title: string;
  body: string;
  type: string;
  read: boolean;
  createdAt?: string;
  createdOn?: string;
};

const initialState = {
  status: '',
  notifications: [] as AppNotification[],
  unreadCount: 0,
  msg: '',
  loading: false,
};

const getNotificationsSlice = createSlice({
  name: 'getNotifications',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.notifications = [];
      state.unreadCount = 0;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getNotifications.pending, state => {
        state.loading = true;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.notifications = action?.payload?.result?.notifications || [];
        state.unreadCount = action?.payload?.result?.unreadCount || 0;
      })
      .addCase(getNotifications.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      })
      // Optimistic local updates — keep the badge honest without a refetch.
      .addCase(markNotificationRead.fulfilled, (state, action) => {
        const id = action.payload?.notificationId;
        const hit = state.notifications.find(n => n._id === id);
        if (hit && !hit.read) {
          hit.read = true;
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
      })
      .addCase(markAllNotificationsRead.fulfilled, state => {
        state.notifications.forEach(n => {
          n.read = true;
        });
        state.unreadCount = 0;
      });
  },
});

export default getNotificationsSlice.reducer;
export const { clearState } = getNotificationsSlice.actions;
